const API_URL =
  process.env.REACT_APP_DASHBOARD_API_URL || "/api/dashboard";

export const fetchDashboardData = async (token) => {
  const response = await fetch(API_URL, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload.error || "Failed to load dashboard");
    error.status = response.status;
    throw error;
  }

  return payload;
};
